import { getSseRefreshOptions } from '../hooks/sse-refresh-policy';
import { useSSEInfiniteQuery } from '../hooks/use-sse-query';
import { CustomUseInfiniteQueryOptions } from '../types';
import { hasNonEmptyProp } from '@/libs/common/utils';
import { ApiInstance, RequireOnly, UserPositions, UserPositionsParams } from '@/libs/sdk/api';
import { keepPreviousData } from '@tanstack/react-query';

export const useUserPositions = (
  api: ApiInstance,
  searchParams: RequireOnly<UserPositionsParams, 'uid'>,
  options?: CustomUseInfiniteQueryOptions<UserPositions>
) => {
  const { page = 1, pageSize = 10 } = searchParams || {};
  const { queryKey, enabled = true, ...rest } = options || {};

  return useSSEInfiniteQuery(
    api.sse,
    {
      ...rest,
      ...getSseRefreshOptions(10_000),
      enabled: enabled && hasNonEmptyProp(searchParams, ['uid']),
      queryKey: [queryKey, 'UserPositions', searchParams],
      initialPageParam: { page, pageSize },
      queryFn: async ({ pageParam }) => {
        const { data } = await api.market.getUserPositions({ ...searchParams!, ...pageParam });
        return { ...data, ...pageParam };
      },
      placeholderData: keepPreviousData,
    },
    [{ event: 'user:position_changed' }]
  );
};
